/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var _require = require('react'),
  useMemo = _require.useMemo;

/**
 * Like `useRef`, but does not warn when accessed during render. It's a bad
 * pattern to read or write from a ref during render as it does not trigger
 * a rerender and might result in bugs.
 */
function useUnsafeRef_DEPRECATED(init) {
  return useMemo(function () {
    return {
      current: init
    };
  }, []);
}
module.exports = useUnsafeRef_DEPRECATED;